let appConfig = {
    baseApiUrl:       process.env.VUE_APP_API_URL,
    juniorBaseApiUrl: process.env.VUE_APP_JUNIOR_API_URL,
    mathBaseApiUrl:   process.env.VUE_APP_MATH_API_URL,
    cabinet:          process.env.VUE_APP_CABINET,
};

export default appConfig;
